import { useLocation } from "react-router-dom";
import Items from "../Aside/Components/Items";
import { determineActiveIndex } from "./asideState";
import { useNotificationCounts } from "../../context/NotificationCountContext";

function HamburgerItem(props) {
  return <Items {...props} tooltipEnabled={false} />;
}

export default function ContainerHamburger({
  isCollapsed,
  onClose = () => {},
}) {
  const { notifCount, ticketCount } = useNotificationCounts();
  const { pathname } = useLocation();
  const activeIndex = determineActiveIndex(pathname);
  const handleCloseMenu = () => {
    if (isCollapsed) return;
    onClose();
  };

  return (
    <>
      <div
        onClick={handleCloseMenu}
        className={`md:hidden absolute right-0 top-0 z-[40] h-dvh bg-black/50 transition-none transition-opacity backdrop-blur ${
          isCollapsed
            ? "w-0 opacity-0 pointer-events-none"
            : "w-dvw opacity-100 pointer-events-auto"
        }`}
      ></div>
      <aside
        className={`md:hidden absolute right-0 top-0 z-40 h-dvh flex flex-col gap-6 rounded-l-2xl drop-shadow-md bg-zi-bg2-light dark:bg-zi-bg2-dark ease-out ${
          isCollapsed ? "w-0 p-0 pt-20" : "w-48 p-3 pt-20"
        }`}
      >
        <div className="overflow-y-auto flex flex-col gap-6 p-0">
          <div className="flex flex-col gap-3">
            <HamburgerItem
              svg_name="dashboard"
              title="میز کار"
              isActive={activeIndex === 1}
              href="/Dashboard"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="purchase"
              title="خرید چالش جدید"
              isActive={activeIndex === 2}
              href="/purchase"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="challenge"
              title="حساب‌ها و چالش‌ها"
              isActive={activeIndex === 3}
              href="/Challenge"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="trade"
              title="معامله"
              isActive={activeIndex === 4}
              href="/trade/account"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            {/* <Items
              svg_name="calculator"
              title="ماشین حساب"
              isActive={activeIndex === 5}
              href="/calculator"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            /> */}
            <HamburgerItem
              svg_name="transaction"
              title="تراکنش‌ها"
              isActive={activeIndex === 6}
              href="/Transaction/Withdraw"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "بخش هدایا" : "."}
            </p>

            {/* <Items svg_name="competition" title="جوایز و مسابقات" isActive={activeIndex === 7} href="/Dashboard" showTitle={!isCollapsed}
              onClick={handleCloseMenu} /> */}
            <HamburgerItem
              svg_name="invite"
              title="دعوت از دوستان"
              isActive={activeIndex === 8}
              href="/invite"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="discount"
              title="کد تخفیف"
              isActive={activeIndex === 9}
              href="/discount"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="certificate"
              title="گواهی‌نامه‌ها"
              isActive={activeIndex === 10}
              href="/certificate/general"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            {/* <Items svg_name="point" title="امتیازات" isActive={activeIndex === 11} href="/Dashboard" showTitle={!isCollapsed}
              onClick={handleCloseMenu} /> */}
          </div>

          <div className="flex flex-col gap-3">
            <p
              className={`text-xs font-normal text-nowrap text-zi-blue-light/50 dark:text-white/50 ${
                isCollapsed && "opacity-0"
              }`}
            >
              {!isCollapsed ? "ناحیه کاربری" : "."}
            </p>
            <HamburgerItem
              svg_name="profile"
              title="حساب کاربری"
              isActive={activeIndex === 12}
              href="/profile/information"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
            <HamburgerItem
              svg_name="notification"
              title="اعلانات"
              isActive={activeIndex === 13}
              href="/notification/all"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
              notifCount={notifCount}
              haveNotifications={
                notifCount && Number(notifCount) > 0 ? true : false
              }
            />
            <HamburgerItem
              svg_name="support"
              title="پشتیبانی"
              isActive={activeIndex === 14}
              href="/support"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
              notifCount={ticketCount}
              haveNotifications={
                ticketCount && Number(ticketCount) > 0 ? true : false
              }
            />
            <HamburgerItem
              svg_name="rules"
              title="قوانین"
              isActive={activeIndex === 15}
              href="/rule/general"
              showTitle={!isCollapsed}
              onClick={handleCloseMenu}
            />
          </div>
        </div>
      </aside>
    </>
  );
}
